import React from 'react';
import './Portfolio.css';

function Portfolio() {
  const projects = [
    {
      title: 'E-Commerce Platform',
      category: 'Web & Mobile',
      description: 'Full-stack e-commerce solution with iOS, Android, and web apps. Features real-time inventory, payment processing, and admin dashboard.',
      image: '🛍️',
      tags: ['React', 'Node.js', 'React Native']
    },
    {
      title: 'Fitness Tracking App',
      category: 'iOS & Android',
      description: 'Health and fitness app with workout tracking, meal planning, and social features. Integrates with Apple Health and Google Fit.',
      image: '💪',
      tags: ['Swift', 'Kotlin', 'Firebase']
    },
    {
      title: 'Restaurant Management',
      category: 'Web Application',
      description: 'Comprehensive restaurant management system with table reservations, online ordering, and analytics dashboard.',
      image: '🍽️',
      tags: ['Vue.js', 'Express', 'PostgreSQL']
    },
    {
      title: 'Social Media Platform',
      category: 'Cross-Platform',
      description: 'Innovative social networking app with real-time messaging, media sharing, and community features.',
      image: '💬',
      tags: ['Flutter', 'Firebase', 'Cloud Functions']
    },
    {
      title: 'Real Estate Marketplace',
      category: 'Web & Mobile',
      description: 'Property listing platform with advanced search, virtual tours, and agent management system.',
      image: '🏠',
      tags: ['React', 'MongoDB', 'Swift']
    },
    {
      title: 'Educational Platform',
      category: 'Web Application',
      description: 'Online learning platform with video courses, assessments, progress tracking, and certification.',
      image: '📚',
      tags: ['Next.js', 'Python', 'AWS']
    }
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            Explore some of our recent work. Each project is a testament to our commitment 
            to quality, innovation, and client satisfaction.
          </p>
        </div>

        <div className="portfolio-grid">
          {projects.map((project, index) => (
            <div className="portfolio-card" key={index} style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="project-image">{project.image}</div>
              <div className="project-content">
                <div className="project-category">{project.category}</div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tags">
                  {project.tags.map((tag, idx) => (
                    <span className="tag" key={idx}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
